import React from "react"
import styled from "styled-components"

const TheSSDifference = ({title, options}) => {
    console.log(title);
  return (
    <Wrapper>
      <h2>{title}</h2>
      <div className="blocks">
        {options.map((item, index) => {
          return (           
              <div key={index} className="block">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>            
          )
        })}
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`

  h2 { margin-left: 20px; font-size: 30px; line-height: 47px; }
  .blocks { display: flex; flex-direction: column; width: 100vw; }
  .block {
    margin-bottom: 40px;
    padding: 20px;
    background: var(--clr-white);
    color: var(--clr-primary-5);
    
    box-shadow: var(--light-shadow);
  }
  h3 { font-size: 22px; line-height: 35px; } 
  p { font-size: 12px; line-height: 190%; color: var(--clr-primary-4); }

  @media (min-width: 360px) {
    h2 { margin-left: 10%; } .blocks { padding: 0 37px; }
  }
  @media (min-width: 768px) {
    .blocks { padding: 0 54px; }
  }
  @media screen and (min-width: 1024px) {
    h2 { margin-left: 20%; } .blocks { padding: 0 183px; }
  }

  @media (min-width: 1180px) {width: 100%;}
  @media (min-width: 1025px) {
    width: 90vw;
    margin: 0 auto;
    max-width: 1170px;
    .blocks { flex-direction: row; padding: 0; width: 100%;}
    .block { width: 33%; margin-left: 40px;
    :first-child { margin-left: 0px; } }    
    h2 { font-size: 46px; line-height: 72px; margin-left: 0px; }
    h3 { font-size: 28px; line-height: 44px; }
    p { font-size: 16px; }
  }
`

export default TheSSDifference
